import { useState } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import HowItWorks from "@/components/HowItWorks";
import ShowcaseGallery from "@/components/ShowcaseGallery";
import Pricing from "@/components/Pricing";
import OrderWizard from "@/components/OrderWizard";
import Testimonials from "@/components/Testimonials";
import InstagramPromo from "@/components/InstagramPromo";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Landing() {
  const [selectedPackage, setSelectedPackage] = useState("");

  const handleSelect = (id) => {
    setSelectedPackage(id);
    const el = document.getElementById("crear");
    if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  };

  return (
    <div className="relative bg-background">
      <Header />
      <Hero />
      <Marquee />
      <HowItWorks />
      <Pricing onSelect={handleSelect} />
      <OrderWizard selectedPackage={selectedPackage} />
      <Testimonials />
      <ShowcaseGallery />
      <InstagramPromo />
      <FAQ />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
